import Vue from 'vue'
import VueI18n from 'vue-i18n'
import element_zh from 'element-ui/lib/locale/lang/zh-CN'
import element_en from 'element-ui/lib/locale/lang/en'

import zh_cn from './lang/zh.js'
import en_cn from './lang/en.js'
Vue.use(VueI18n)
export const messages = {
	'zh': {
		langName: '简体中文',
		el: {
			...element_zh.el,
			...zh_cn
		},
	},
	'en': {
		langName: 'English',
		el: {
			...element_en.el,
			...en_cn
		}
	}
}

function getLanguage(){
  return localStorage.getItem('lang') || 'en'
}

export const i18n =  new VueI18n({
	locale: getLanguage(),
	messages
})